import React from "react";
import "../supplierAndManufacturers.scss";

const DeleteButton = ({
  isArchive = false,
  isDeleting = false,
  onClick = () => { },
}) => {
  return (
    <div className="hg-delete-button" onClick={onClick}>
      <img alt="" className="mx-2" src={isArchive ? "/images/settings-v2/archived-icon.svg" : "/images/actioncenter/delete.svg"} />
      {isDeleting ? "Deleting..." : isArchive ? "Archive" : "Delete"}
    </div>

  );
};

export default DeleteButton;


export const DefineArchiveButton = ({isArchive=false, onClick = () => { }, isDeleting = false, isUnarchive = false}) => {
  const getLoadingText = () => {
    if (isUnarchive) return "Unarchiving...";
    if (isArchive) return "Archiving...";
    return "Deleting...";
  };

  const getButtonText = () => {
    if (isUnarchive) return "Unarchive";
    if (isArchive) return "Archive";
    return "Delete";
  };

  return (
    <div className="delete-button" onClick={onClick}>
      <img alt="" className="mx-2" width={20} height={20} src={isUnarchive ? "/images/actioncenter/archive.svg" : (isArchive ? "/images/actioncenter/archive.svg" : "/images/actioncenter/delete.svg")} />
      {isDeleting ? getLoadingText() : getButtonText()}
    </div>
  );
};
